import { useMatch, useSearchParams } from "react-router-dom";

export const useRouteTopLevelReference = (): {
  organizationSlug?: string;
  serverId?: string;
  databaseId?: string;
  serverGroupId?: string;
} => {
  const databaseMatch = useMatch(`/databases/:databaseId/*`);
  const serverMatch = useMatch(`/servers/:serverId/*`);
  const serverGroupMatch = useMatch(`/servergroups/:serverGroupId/*`);
  const organizationMatch = useMatch(`/organizations/:slug/*`);
  const queryZoomMatch = useMatch(`/queries/:fingerprint`);
  const [searchParams] = useSearchParams();
  if (databaseMatch) {
    return { databaseId: databaseMatch.params["databaseId"] };
  }
  if (serverMatch) {
    return { serverId: serverMatch.params["serverId"] };
  }
  if (serverGroupMatch) {
    return { serverGroupId: serverGroupMatch.params["serverGroupId"] };
  }
  if (organizationMatch) {
    const organizationSlug =
      (organizationMatch.params["slug"] !== "new" &&
        organizationMatch.params["slug"]) ||
      undefined;
    return { organizationSlug };
  }
  if (queryZoomMatch) {
    const serverGroupId = searchParams.get("servergroup");
    if (serverGroupId) {
      return { serverGroupId };
    }
    const organizationSlug = searchParams.get("organization");
    if (organizationSlug) {
      return { organizationSlug };
    }
  }
  return {};
};
